export const GET_CALENDAR_EVENTS = "GET_CALENDAR_EVENTS"
export const GET_CALENDAR_EVENTS_SUCCESS = "GET_CALENDAR_EVENTS_SUCCESS"
export const GET_CALENDAR_EVENTS_FAILED = "GET_CALENDAR_EVENTS_FAILED"

export const GET_CALENDAR_EVENT_FEATURE = "GET_CALENDAR_EVENT_FEATURE"
export const GET_CALENDAR_EVENT_FEATURE_SUCCESS =
  "GET_CALENDAR_EVENT_FEATURE_SUCCESS"
export const GET_CALENDAR_EVENT_FEATURE_FAILED =
  "GET_CALENDAR_EVENT_FEATURE_FAILED"
export const RESET_CALENDAR_EVENT_FEATURE = "RESET_CALENDAR_EVENT_FEATURE"

export const UPDATE_CALENDAR_EVENTS = "UPDATE_CALENDAR_EVENTS"
export const UPDATE_CALENDAR_EVENTS_SUCCESS = "UPDATE_CALENDAR_EVENTS_SUCCESS"
export const UPDATE_CALENDAR_EVENTS_FAILED = "UPDATE_CALENDAR_EVENTS_FAILED"

export const GET_CALENDAR_REPORTS = "GET_CALENDAR_REPORTS"
export const GET_CALENDAR_REPORTS_SUCCESS = "GET_CALENDAR_REPORTS_SUCCESS"
export const GET_CALENDAR_REPORTS_FAILED = "GET_CALENDAR_REPORTS_FAILED"
export const RESET_CALENDAR_REPORTS = "RESET_CALENDAR_REPORTS"
